import { AnyAction } from 'redux';
import { ActionTypes, ILBState } from './types/state.types';

const initialState: ILBState = {
  list: [],
};

const vmReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: ILBState = initialState,
  { type, payload }: AnyAction,
): ILBState => {
  switch (type) {
    case ActionTypes.SET_LIST:
      return { ...state, list: payload };
    default:
      return state;
  }
};

export default vmReducer;
